import React, { Component } from "react";
import { StoryElement, ImageGalleryElement } from "@quintype/components";
import { object, string } from "prop-types";
import LightBox from "../../molecules/lightbox";
import AlsoRead from "../../molecules/also-read";

import "./story-card.m.css";

class StoryCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryItemIndex: 0
    };
    this.galleryItems = [];
    this.togglePopup = this.togglePopup.bind(this);
  }

  togglePopup(index) {
    this.setState({
      showPopup: !this.state.showPopup,
      galleryItemIndex: index
    });
  }

  render() {
    const templates = {
      "also-read": AlsoRead
    };

    return (
      <div styleName="wrapper">
        {this.props.card["story-elements"].map((element, index) => {
          switch (element.subtype) {
            case "image-gallery":
              if (element.metadata.type === "gallery") {
                return (
                  <div key={index}>
                    {element.type === "composite" ? (
                      <ImageGalleryElement
                        story={this.props.story}
                        element={element}
                        key={element.id}
                        imageAspectRatio={[1, 1]}
                        onClickHandler={this.togglePopup}
                      />
                    ) : (
                      <StoryElement renderTemplates={templates} story={this.props.story} element={element} />
                    )}
                    <div>
                      {this.state.showPopup ? (
                        <LightBox
                          element={element["story-elements"][this.state.galleryItemIndex]}
                          closePopup={this.togglePopup}
                        />
                      ) : null}
                    </div>
                  </div>
                );
              }
              break;
            default:
              if (this.props.excludeElementId !== element.id) {
                return (
                  <div key={index}>
                    <StoryElement renderTemplates={templates} story={this.props.story} element={element} />
                  </div>
                );
              } else {
                return null;
              }
          }
        })}
      </div>
    );
  }
}

StoryCard.propTypes = {
  card: object,
  story: object,
  excludeElementId: string
};

export default StoryCard;
